import { isAfter } from 'date-fns';

export function UseExpirationDate(expirationDate) {
  const currentDate = new Date();
  const formattedExpirationDate = new Date(expirationDate);

  return isAfter(currentDate, formattedExpirationDate);
}